'use strict';

var CellRenderer = require('./CellRenderer');

var round = Math.round;

/**
 * @constructor
 * @extends CellRenderer
 */
var ThumbnailCell = CellRenderer.extend('ThumbnailCell', {

	/**
	 * @desc Display thumbnail
	 * @implements paintFunction
	 * @memberOf ThumbnailCell.prototype
	 */
	paint: function(gc, config) {
		var bounds        = config.bounds,
			height        = bounds.height,
			width         = bounds.width,
			x             = bounds.x,
			y             = bounds.y,
			thumbnail     = config.value,
			partialRender = config.prefillColor === undefined, // signifies abort before rendering if same
			snapshot      = config.snapshot,
			same          = snapshot && partialRender,
			ixoffset, iyoffset,
			hover, hoverColor, selectColor, foundationColor, inheritsBackgroundColor,
			c, colors,
			ratio, thumbnailHeight, thumbnailWidth;

		same = same && thumbnail === snapshot.value;

		// fill background only if our bgColor is populated or we are a selected cell
		colors = [];
		c = 0;
		if (config.isCellHovered && config.hoverCellHighlight.enabled) {
			hoverColor = config.hoverCellHighlight.backgroundColor;
		} else if (config.isRowHovered && (hover = config.hoverRowHighlight).enabled) {
			hoverColor = config.isDataColumn || !hover.header || hover.header.backgroundColor === undefined ? hover.backgroundColor : hover.header.backgroundColor;
		} else if (config.isColumnHovered && (hover = config.hoverColumnHighlight).enabled) {
			hoverColor = config.isDataRow || !hover.header || hover.header.backgroundColor === undefined ? hover.backgroundColor : hover.header.backgroundColor;
		}
		if (gc.alpha(hoverColor) < 1) {
			if (config.isSelected) {
				selectColor = config.backgroundSelectionColor;
			}

			if (gc.alpha(selectColor) < 1) {
				inheritsBackgroundColor = (config.backgroundColor === config.prefillColor);
				if (!inheritsBackgroundColor) {
					foundationColor = true;
					colors.push(config.backgroundColor);
					same =  same && foundationColor === snapshot.foundationColor &&
							config.backgroundColor === snapshot.colors[c++];
				}
			}

			if (selectColor !== undefined) {
				colors.push(selectColor);
				same = same && selectColor === snapshot.colors[c++];
			}
		}
		if (hoverColor !== undefined) {
			colors.push(hoverColor);
			same = same && hoverColor === snapshot.colors[c++];
		}

		if (same && c === snapshot.colors.length) {
			return;
		}

		// return a snapshot to save in cellEvent for future comparisons by partial renderer
		config.snapshot = {
			value: thumbnail,
			foundationColor: foundationColor,
			colors: colors
		};

		layerColors(gc, colors, x, y, width, height, foundationColor);

		ratio           = thumbnail.naturalWidth / thumbnail.naturalHeight;
		thumbnailHeight = thumbnail.height;
		thumbnailWidth  = thumbnail.width;

		if (thumbnailWidth >= width - 10) {
			thumbnailWidth = width - 10;
			thumbnailHeight = thumbnailWidth / ratio;
		}
		if (thumbnailHeight >= height - 10) {
			thumbnailHeight = height - 10;
			thumbnailWidth = thumbnailHeight * ratio;
		}
		iyoffset = round((height - thumbnailHeight) / 2);
		ixoffset = round((width - thumbnailWidth) / 2);
		gc.drawImage(thumbnail, x + width - ixoffset - thumbnailWidth, y + iyoffset, thumbnailWidth, thumbnailHeight);

		config.minWidth = config.iconPadding * 2 + Math.max(thumbnailWidth + 2);
	}
});

function layerColors(gc, colors, x, y, width, height, foundationColor) {
    for (var i = 0; i < colors.length; i++) {
        if (foundationColor && !i) {
            gc.clearFill(x, y, width, height, colors[i]);
        } else {
            gc.cache.fillStyle = colors[i];
            gc.fillRect(x, y, width, height);
        }
    }
}

module.exports = ThumbnailCell;
